import { createFetch } from "../../fetch/FetchRequest";
import { getCookie } from "../../common";
import { shouldAbortFetchErrorHandling } from "../../fetch/common";
import { API_AGREEMENT_OWN_EXTERNAL, API_AGREEMENT_OWN_ACCEPTED_EXTERNAL } from "../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../settings/global";

export function getAgreementStatusFor(agreementID, onSuccess, onError) {
    createFetch({
        URL: `${API_AGREEMENT_OWN_ACCEPTED_EXTERNAL}/${agreementID}`,
        headers: {'Authorization': `Bearer ${getCookie(USER_ACCESS_TOKEN_NAME)}`},
        method: 'GET',
        onSuccess: response => {
            if (onSuccess) onSuccess(response);
        },
        onError: response => {
            if (shouldAbortFetchErrorHandling(response)) return;
            if (onError) onError(response);
        }
    })
}

export function setAgreedFor(agreementID, onSuccess, onError) {
    createFetch({
        URL: API_AGREEMENT_OWN_EXTERNAL,
        headers: {
            'Authorization': `Bearer ${getCookie(USER_ACCESS_TOKEN_NAME)}`,
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: {agrt_id: agreementID},
        onSuccess: response => {
            if (onSuccess) onSuccess(response);
        },
        onError: response => {
            if (shouldAbortFetchErrorHandling(response)) return;
            if (onError) onError(response);
        }
    })
}